import styled from 'styled-components'

const ClickableCell = styled.div`
  color: ${({ theme }) => theme.colors.blue1};
  cursor: pointer;
`

export default ClickableCell
